import Ajv from 'ajv';
import addFormats from 'ajv-formats';

export function getJsonSchemaValidator(shouldRemoveAdditional?: boolean) {
    return addFormats(new Ajv({ coerceTypes: true, allErrors: true, removeAdditional: shouldRemoveAdditional ?? false, strict: true }), [
        'date-time',
        'time',
        'date',
        'email',
        'hostname',
        'ipv4',
        'ipv6',
        'uri',
        'uri-reference',
        'uuid',
        'uri-template',
        'json-pointer',
        'relative-json-pointer',
        'regex',
    ])
        .addKeyword('kind')
        .addKeyword('modifier');
}
